import React, { useState, useEffect, useContext, useCallback } from "react";
import { withRouter, useHistory } from "react-router-dom";
import DispatchContext from "../../contexts/DispatchContext";
import DataFetcher from "../../utils/DataFetcher";

import FormUser from "../forms/FormUser";
import LoadingIndicator from "../elements/LoadingIndicator";

import { getResponse, dispError, dispSuccess, getSalutation, getUserType, getUserState } from "../../utils/Tools";

function User(props) {
  const appDispatch = useContext(DispatchContext);
  const history = useHistory();
  const [editMode, setEditMode] = useState(false);
  const [userData, setData] = useState(null);
  const userID = props.match.params.id;

  const onDelete = id => {
    let confirm = window.confirm(getResponse("006a"));
    if (confirm) {
      DataFetcher.fetch(DataFetcher.USER.DELETE, { _id: id })
        .then(response => {
          if (!response.success) {
            appDispatch(dispError(response.msg));
            return history.push("/");
          }
          appDispatch(dispSuccess(getResponse("006b")));
          return history.push("/user/list");
        })
        .catch(error => {
          console.error(error);
          return history.push("/");
        });
    }
  };
  const onUpdate = () => {
    setEditMode(false);
    loadData();
  };
  const loadData = useCallback(() => {
    DataFetcher.fetch(DataFetcher.USER.DETAIL, { _id: userID })
      .then(response => {
        if (!response.success) {
          appDispatch(dispError(response.msg));
          return history.push("/");
        }
        return setData(response.user);
      })
      .catch(error => {
        console.error(error);
        return history.push("/");
      });
  }, [userID, appDispatch, history]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    window.document.title = props.title;
  }, [props.title]);

  return (
    <main className="user">
      {!userData && <LoadingIndicator />}
      {userData && (
        <>
          <h1 className="title">
            Details: {userData.firstname} {userData.lastname}
          </h1>
          {editMode && (
            <FormUser
              prefill={userData}
              modus="edit"
              onCancel={e => {
                setEditMode(false);
              }}
              onUpdate={onUpdate}
            />
          )}
          {!editMode && (
            <>
              <p>
                <strong>
                  {getSalutation(userData.salutation)} {userData.firstname} {userData.lastname}
                </strong>
                <br />
                {userData.email}
              </p>
              <hr />
              <p>
                <strong>Rechte:</strong> {getUserType(userData.type)}
                <br />
                <span className="client-status">
                  <strong>Status:</strong>{" "}
                  <span className="icon">
                    <i className={getUserState(userData.isActivated, Boolean(userData.isDeleted)).icon}></i>
                  </span>{" "}
                  {getUserState(userData.isActivated, Boolean(userData.isDeleted)).text}
                </span>
              </p>
              <div className="field field-body">
                <button
                  className="button"
                  onClick={e => {
                    history.goBack();
                  }}>
                  Zurück
                </button>
                {!Boolean(userData.isDeleted) && (
                  <>
                    <button
                      className="button is-success ml-2"
                      onClick={e => {
                        setEditMode(true);
                      }}>
                      Bearbeiten
                    </button>
                    <button
                      className="button is-danger ml-2"
                      onClick={e => {
                        onDelete(userData._id);
                      }}>
                      Löschen
                    </button>
                  </>
                )}
              </div>
            </>
          )}
        </>
      )}
    </main>
  );
}
export default withRouter(User);
